<div
  [class]="rootClasses"
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()"
  (mousedown)="onMouseDown()"
  (mouseup)="onMouseUp()"
>
  <span *ngIf="type === 'outline'" class="info-chip-dot" aria-hidden="true"></span>
  <mat-icon *ngIf="type === 'filled' && iconLeading" class="info-chip-icon leading" [class]="iconSet">{{ iconLeading }}</mat-icon>

  <span class="info-chip-label">{{ label }}</span>

  <mat-icon *ngIf="iconTrailing && !removable" class="info-chip-icon trailing" [class]="iconSet">{{ iconTrailing }}</mat-icon>

  <button *ngIf="removable" type="button" (click)="handleRemove($event)" class="info-chip-icon remove" aria-label="Quitar info chip">
    <mat-icon [class]="iconSet">cancel</mat-icon>
  </button>
</div>
